module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-54.79535dea.svg";